import { createContext, useContext } from "react";
import type { DrawerStackEntry } from "./types";

export interface DrawerStackContextValue {
  /** The current stack of open drawers (bottom to top) */
  stack: DrawerStackEntry[];
  /** Push a new drawer onto the stack (opens on top) */
  pushDrawer: (entry: Omit<DrawerStackEntry, "id"> & { id?: string }) => void;
  /** Pop the topmost drawer off the stack (close button behavior) */
  popDrawer: () => void;
  /** Close all drawers in the stack (backdrop click behavior) */
  closeAll: () => void;
  /** Close a specific drawer by id and all drawers above it */
  closeFrom: (id: string) => void;
}

export const DrawerStackContext = createContext<DrawerStackContextValue | undefined>(undefined);

export function useDrawerStack(): DrawerStackContextValue {
  const context = useContext(DrawerStackContext);
  if (!context) {
    throw new Error("useDrawerStack must be used within a DrawerStackProvider");
  }
  return context;
}

